// Build version baked in at compile time via REACT_APP_VERSION (sourced from
// package.json by the dev/build scripts). Displayed in the sidebar and used to
// detect when a returning user is running an outdated build.
export const APP_VERSION = process.env.REACT_APP_VERSION || "0.0.0";

const STORAGE_KEY = "bhpr-web-app-version";

// When the deployed version changes, purge any Cache Storage entries and
// service workers so returning users pick up the newest build automatically,
// without having to clear their browsing data. Reloads once on upgrade.
export async function ensureLatestVersion() {
	try {
		const stored = window.localStorage.getItem(STORAGE_KEY);
		if (stored === APP_VERSION) return;

		const isUpgrade = Boolean(stored);
		window.localStorage.setItem(STORAGE_KEY, APP_VERSION);

		if ("caches" in window) {
			const keys = await caches.keys();
			await Promise.all(keys.map((key) => caches.delete(key)));
		}
		if ("serviceWorker" in navigator) {
			const registrations = await navigator.serviceWorker.getRegistrations();
			await Promise.all(registrations.map((registration) => registration.unregister()));
		}

		// Only force a reload when upgrading an existing install, never on the
		// very first visit (nothing stale to clear yet).
		if (isUpgrade) {
			window.location.reload();
		}
	} catch {
		// Cache cleanup must never block app startup.
	}
}
